module.exports = __webpack_public_path__ + "/img/1862dea2fa16d72b78f2f726ab685e9a.png";